import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.featured-services.splide' ).each( function( index, element ) {
        const slider = new Splide( element, {
          type: 'loop',
          gap: '2rem',
          perPage: 3,
          perMove: 1,
          pagination: false,
          speed: 800,
          breakpoints: {
            1024: {
              perPage: 2,
            },
            768: {
              perPage: 1,
              gap: '1rem',
            },
          },
        } );

        slider.on( 'overflow', function( isOverflow ) {
          slider.options = {
            arrows: isOverflow,
            drag: isOverflow,
          };
        } );

        slider.mount();
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'featured-services', COMPONENT );
} )( app );
